// React hook exposing the logged-in patient's product/profile metadata.
//
// Thin convenience wrapper over `usePatientProfile()` that returns just the
// resolved profile (or `null` until it resolves), so consumers don't have to
// destructure the context value.
//
// Pure patient data — auth concerns live elsewhere: access code / token come
// from `useAuthCredentials()` and `email` from `useAuth().user.email`. Neither
// depends on the patient profile.
import {
  PatientProfile,
  usePatientProfile,
} from "@modules/authentication/PatientProfileProvider";

export const usePatient = (): PatientProfile | null => {
  const { profile } = usePatientProfile();
  return profile;
};
